/**
 * Keyset-Cursor fuer den Workbench-Reviewer.
 *
 * Der Reviewer laeuft ueber eine Menge, die durch seine eigenen Freigaben
 * schrumpft. Ein Offset wandert dabei mit und ueberspringt Produkte
 * (siehe Spec, Phase 0, P0-1). Ein Keyset-Cursor bleibt gueltig, weil er
 * an Werte gebunden ist, nicht an Positionen.
 *
 * Sortierung, auf die dieser Cursor sich bezieht:
 *   .order('last_optimized_at', { ascending: true, nullsFirst: false })
 *   .order('id', { ascending: true })
 *
 * `last_optimized_at` ist nullable, deshalb zwei Segmente: erst alle Zeilen
 * mit Wert, danach alle mit NULL.
 */
export interface WorkbenchCursor {
  lastOptimizedAt: string | null;
  id: string;
}

export function cursorFromRow(row: { last_optimized_at: string | null; id: string }): WorkbenchCursor {
  return { lastOptimizedAt: row.last_optimized_at, id: row.id };
}

/**
 * Baut den Ausdruck fuer `query.or(...)`, der genau die Zeilen NACH dem
 * Cursor auswaehlt. Gibt null zurueck, wenn kein Cursor gesetzt ist; dann
 * laedt der Aufrufer die erste Seite ungefiltert.
 *
 * Werte werden in doppelte Anfuehrungszeichen gesetzt, weil PostgREST sonst
 * das `+` in ISO-Zeitstempeln als Leerzeichen interpretiert.
 */
export function buildKeysetFilter(cursor: WorkbenchCursor | null): string | null {
  if (!cursor) return null;

  if (cursor.lastOptimizedAt === null) {
    // Bereits im NULL-Segment: nur noch nach id weiterlaufen.
    return `and(last_optimized_at.is.null,id.gt."${cursor.id}")`;
  }

  const t = cursor.lastOptimizedAt;
  return (
    `last_optimized_at.gt."${t}",` +
    `and(last_optimized_at.eq."${t}",id.gt."${cursor.id}"),` +
    `last_optimized_at.is.null`
  );
}
